export enum OpportunityAttemptEnum {
    FIRST_ATTEMPT_ONLY = 'FIRST_ATTEMPT_ONLY',
    SECOND_AND_NEXT_ATTEMPTS_ONLY = 'SECOND_AND_NEXT_ATTEMPTS_ONLY'
}

export enum OpportunityAttemptLabelEnum {
    FIRST_ATTEMPT_ONLY = 'Apenas LEADs novos',
    SECOND_AND_NEXT_ATTEMPTS_ONLY = 'Apenas LEADs de 2ª oportunidade'
}
